import { h } from '@stencil/core';

const Icon = ({ width = '16px', height = '16px'}) => {
  return (
     <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1426_4884" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.78 7.91C15.78 3.54 12.25 0 7.89 0C3.53 0 0 3.54 0 7.91C0 12.28 3.53 15.82 7.89 15.82C12.25 15.82 15.78 12.28 15.78 7.91ZM1.5 7.91C1.5 4.37 4.36 1.5 7.89 1.5C11.42 1.5 14.28 4.37 14.28 7.91C14.28 11.45 11.42 14.32 7.89 14.32C4.36 14.32 1.5 11.45 1.5 7.91ZM8.68 12.07V6.59C8.68 6.18 8.34 5.84 7.93 5.84C7.52 5.84 7.18 6.18 7.18 6.59V12.07C7.18 12.48 7.52 12.82 7.93 12.82C8.34 12.82 8.68 12.48 8.68 12.07ZM8.66 3.55V3.96C8.66 4.37 8.32 4.71 7.91 4.71C7.5 4.71 7.16 4.37 7.16 3.96V3.55C7.16 3.14 7.5 2.8 7.91 2.8C8.32 2.8 8.66 3.14 8.66 3.55Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_1426_4884)">
        <rect width="16" height="16" fill="#2B5195" />
      </g>
    </svg>
  );
};

export default Icon;
